module.exports = __webpack_public_path__ + "img/correspondent-logo--dark-text.4477bdab.png";